"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fullCalendarThemeSx = void 0;
// Themes FullCalendar (v5) surfaces via its CSS custom properties so the
// calendar grid follows light/dark mode. Light values match FullCalendar's
// defaults (white page, #ddd-ish borders, faint grey header cells).
// Usage: <Box sx={[fullCalendarThemeSx, ...]}> around <FullCalendar />.
var fullCalendarThemeSx = function (theme) { return ({
    "& .fc": {
        "--fc-page-bg-color": theme.palette.background.paper,
        "--fc-neutral-bg-color": theme.palette.grey[100],
        "--fc-border-color": theme.palette.grey[300],
        "--fc-list-event-hover-bg-color": theme.palette.action.hover,
    },
}); };
exports.fullCalendarThemeSx = fullCalendarThemeSx;
//# sourceMappingURL=calendarStyles.js.map